var React = require('react');

function IconSocialFacebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#242424","fillOpacity":".3","key":0}),React.createElement("path",{"d":"M20.345 16.502l.518-3.379h-3.242v-2.192c0-.925.453-1.826 1.905-1.826H21V6.228S19.662 6 18.383 6c-2.67 0-4.415 1.618-4.415 4.548v2.575H11v3.38h2.968V25h3.653v-8.498h2.724z","fill":"#fff","key":1})]);
}

IconSocialFacebook.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = IconSocialFacebook;

IconSocialFacebook.default = IconSocialFacebook;
